import React, { useEffect, useState } from 'react';
import { Form } from 'antd';
import FormPageView from '../../components/dynamicForms/FormPageView';
import { PREVIEW_MESSAGES } from '../../components/dynamicForms/previewProtocol';

/**
 * The public form page fed by the admin editor instead of the API. It is loaded in an iframe
 * by LivePreview, so the preview has its own viewport: phone and desktop widths, breakpoints
 * and the page's own styles behave exactly as on /client-portal/:slug.
 *
 * View only: the page is inert, so nothing can be clicked, typed into, uploaded or submitted.
 * It still scrolls.
 */
const FormPreview = () => {
  const [form] = Form.useForm();
  const [data, setData] = useState(null);

  useEffect(() => {
    const fromEditor = (event) => event.origin === window.location.origin && event.source === window.parent;

    const onMessage = (event) => {
      if (!fromEditor(event) || !event.data) return;
      if (event.data.type === PREVIEW_MESSAGES.data) {
        setData(event.data.data);
      } else if (event.data.type === PREVIEW_MESSAGES.focus) {
        const item = [...document.querySelectorAll('[data-field-name]')].find((el) => el.dataset.fieldName === event.data.fieldName);
        if (item) {
          // scroll this page only; scrollIntoView would also scroll the editor around the iframe
          const rect = item.getBoundingClientRect();
          const top = window.scrollY + rect.top - Math.max(16, (window.innerHeight - rect.height) / 2);
          window.scrollTo({ top: Math.max(0, top), behavior: event.data.instant ? 'auto' : 'smooth' });
        }
      }
    };

    window.addEventListener('message', onMessage);
    if (window.parent !== window) {
      window.parent.postMessage({ type: PREVIEW_MESSAGES.ready }, window.location.origin);
    }
    return () => window.removeEventListener('message', onMessage);
  }, []);

  if (!data) {
    return (
      <div style={{ minHeight: '100vh', background: '#fafafa' }} aria-busy="true" />
    );
  }

  return (
    <div inert style={{ cursor: 'default' }}>
      <FormPageView data={data} form={form} onFinish={() => {}} onLogoClick={() => {}} />
    </div>
  );
};

export default FormPreview;
